import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';

import { AUTH_SESSION } from './auth-session.token';
import { KeycloakAuthSession } from './keycloak-auth-session';

export function provideAuthSession(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: AUTH_SESSION, useExisting: KeycloakAuthSession },
    provideAppInitializer(async () => {
      await inject(KeycloakAuthSession).initialise();
    }),
  ]);
}
